import React from 'react'
import CallSetting from '../../components/Call/CallSetting'

function CallSettingPage() {
  return (
    <CallSetting/>
  )
}

export default CallSettingPage